import { createActor } from 'xstate';
import {
  searchMachine,
  EventType,
  SearchMachineContext,
} from 'xstate/machines/SearchMachine';

export const SearchActor = createActor(searchMachine);
SearchActor.start();

// Load persisted recent searches from storage. Call from a mount effect (not
// at import) so the server and the client's first render agree — reading
// localStorage eagerly would desync hydration on the search screen's idle list.
export const loadRecentSearches = (): void => {
  SearchActor.send({ type: EventType.LoadRecents });
};

// Helpers

// Set the active search term without recording it as a recent (e.g. seeding
// from the `?q` URL param).
export const setSearchQuery = (query: string): void => {
  SearchActor.send({ type: EventType.SetQuery, query });
};

// Commit a search term: sets it and records it in recent searches.
export const submitSearch = (query: string): void => {
  SearchActor.send({ type: EventType.Submit, query });
};

export const setSearchBoxFilter = (boxId: string | null): void => {
  SearchActor.send({ type: EventType.SetBoxFilter, boxId });
};

export const setSearchCollectionFilter = (
  collectionId: string | null,
): void => {
  SearchActor.send({ type: EventType.SetCollectionFilter, collectionId });
};

export const clearSearch = (): void => {
  SearchActor.send({ type: EventType.Clear });
};

export const deleteRecentSearch = (query: string): void => {
  SearchActor.send({ type: EventType.DeleteRecent, query });
};

// Selectors

export const Selectors = {
  query: (s: { context: SearchMachineContext }) => s.context.query,
  filterBoxId: (s: { context: SearchMachineContext }) => s.context.filterBoxId,
  filterCollectionId: (s: { context: SearchMachineContext }) =>
    s.context.filterCollectionId,
  recentSearches: (s: { context: SearchMachineContext }) =>
    s.context.recentSearches,
};
